import React from 'react';
import { C, font, serif } from '../shared/constants';
import { useScrollReveal, revealStyle } from '../shared';
import { Bar } from '../landing';

const CARDS = [
  {
    verb: 'Lo actualizas',
    em: 'Lo vuelves presente, aquí y ahora.',
    body: 'Tu negocio deja de ser una idea en el aire. En el árbol marcas dónde estás hoy, con evidencia, y sabes exactamente qué sigue.',
    where: '→ El árbol de misiones',
    color: C.turquesa,
  },
  {
    verb: 'Lo representas',
    em: 'Le das forma visible.',
    body: 'Tu carta de negocio: nombre, producto estrella, marca, redes e insignias. Lo que antes solo tú veías, ahora lo ven clientes, emprendedores y donantes.',
    where: '→ Tu carta',
    color: C.mango,
  },
  {
    verb: 'Lo acompañas',
    em: 'Participas en él junto a otros.',
    body: 'No lo haces solo. Una red de emprendedores que anotan sus aciertos y errores, y Genio y Luca, dos inteligencias que te empujan y te aterrizan.',
    where: '→ La red, Genio y Luca',
    color: C.turquesa,
  },
  {
    verb: 'Lo realizas',
    em: 'Ayudas a que ocurra.',
    body: 'Como la danza de primavera colabora para que llegue la primavera, cada misión y cada milestone colaboran para que tu empresa ocurra: sana, con empleos y lista para recibir donaciones.',
    where: '→ Milestones y crowdfunding',
    color: C.coral,
  },
];

export default function Ritual4({ isMobile, isTablet }) {
  const reveal = useScrollReveal();
  const mob = isMobile;
  const grad = `linear-gradient(90deg, ${C.turquesa} 0%, ${C.mango} 55%, ${C.coral} 100%)`;

  return (
    <section
      ref={reveal.ref}
      style={{
        maxWidth: 1180, margin: '0 auto',
        padding: mob ? '2.5rem 1rem' : '4rem 1.5rem',
        textAlign: 'center',
        borderTop: `1px solid ${C.border}`,
        ...revealStyle(reveal.inView),
      }}
    >
      {/* Eyebrow */}
      <p style={{
        fontSize: mob ? 11 : 12, letterSpacing: 3, fontWeight: 700,
        textTransform: 'uppercase', color: C.coral, margin: '0 0 14px',
      }}>
        Qué hace Thinker & Doer con tu proyecto
      </p>

      {/* Headline */}
      <h2 style={{
        fontFamily: serif, fontSize: mob ? 24 : isTablet ? 36 : 48,
        fontWeight: 400, lineHeight: 1, margin: '0 auto 28px', maxWidth: 860,
        color: '#fff',
      }}>
        Tu proyecto ya existe en tu cabeza. Aquí{' '}
        <em style={{
          background: grad, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          backgroundClip: 'text', fontStyle: 'italic',
        }}>
          lo actualizas, lo representas, lo acompañas y lo realizas.
        </em>
      </h2>

      {/* 4 cards grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: mob ? '1fr' : isTablet ? '1fr 1fr' : 'repeat(4, 1fr)',
        gap: 16, textAlign: 'left',
      }}>
        {CARDS.map((c, i) => (
          <div
            key={i}
            style={{
              background: 'rgba(255,255,255,0.04)',
              border: `1px solid ${C.border}`,
              borderTop: `3px solid ${c.color}`,
              borderRadius: 18, padding: 24,
              display: 'flex', flexDirection: 'column', gap: 8,
              boxShadow: `0 0 36px rgba(${hexToRgb(c.color)}, 0.1)`,
              transition: 'transform 0.4s cubic-bezier(.16,1,.3,1), box-shadow 0.4s, border-color 0.3s',
              cursor: 'default',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.boxShadow = `0 20px 50px rgba(${hexToRgb(c.color)}, 0.28)`;
              e.currentTarget.style.borderColor = c.color;
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = `0 0 36px rgba(${hexToRgb(c.color)}, 0.1)`;
              e.currentTarget.style.borderColor = C.border;
            }}
          >
            <span style={{ fontFamily: serif, fontSize: 30, lineHeight: 1, color: c.color }}>
              {c.verb}
            </span>
            <em style={{ fontSize: 14, color: '#fff', fontStyle: 'italic' }}>{c.em}</em>
            <p style={{ margin: '4px 0 0', fontSize: 14, color: 'rgba(255,255,255,0.55)', lineHeight: 1.6, flex: 1 }}>
              {c.body}
            </p>
            <span style={{ fontSize: 12, fontWeight: 700, color: c.color }}>{c.where}</span>
          </div>
        ))}
      </div>

      {/* Bottom line */}
      <p style={{ margin: '26px 0 0', color: 'rgba(255,255,255,0.55)', fontSize: 16 }}>
        Cuatro verbos. Un solo árbol.{' '}
        <a href="#" onClick={e => { e.preventDefault(); document.querySelector('.td-pulse-btn')?.click(); }}
          style={{ color: C.turquesa, fontWeight: 700, textDecoration: 'none' }}>
          Empieza gratis →
        </a>
      </p>
    </section>
  );
}

/* Helper: hex → rgb string for rgba() */
function hexToRgb(hex) {
  const h = hex.replace('#', '');
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return `${r},${g},${b}`;
}
